import { createBrowserHistory } from '@medlinker/fundamental';
import rewriteHistory from './Routes/rewriteHistory';

const history = createBrowserHistory({
  basename: '/ih-v2',
});

rewriteHistory(history);

export default history;
